import React from "react";
import Mumbai from "../Statics/Mumbai.png";
import Delhi from "../Statics/Delhi.png";
import Indore from "../Statics/Indore.png";
import Hydrabad from "../Statics/Hydrabad.png";
import Assam from "../Statics/Assam.png";
import Kolkata from "../Statics/Kolkata.png";

const Venues = () => {
  return (
    <>
      <div class="card text-center m-3">
        <div class="card-body">
          <h5 class="card-title">MUMBAI</h5>
          <p>
            <b>DY Patil Stadium</b>
          </p>
          <img
            src={Mumbai}
            style={{ width: "250px", height:"280px" }}
            class="d-inline-block align-top"
            alt=""
          />
        </div>
      </div>
      <div class="card text-center m-3">
        <div class="card-body">
          <h5 class="card-title">DELHI</h5>
          <p>
            <b>Feroz Shah Kotla Stadium</b>
          </p>
          <img
            src={Delhi}
            style={{ width: "250px", height:"280px" }}
            class="d-inline-block align-top"
            alt=""
          />
        </div>
      </div>
      <div class="card text-center m-3">
        <div class="card-body">
          <h5 class="card-title">HYDRABAD</h5>
          <p>
            <b>Rajiv Gandhi International Cricket Stadium</b>
          </p>
          <img
            src={Hydrabad}
            style={{ width: "250px", height:"280px" }}
            class="d-inline-block align-top"
            alt=""
          />
        </div>
      </div>
      <div class="card text-center m-3">
        <div class="card-body">
          <h5 class="card-title">KOLKATA</h5>
          <p>
            <b>Sden Garden Cricket Stadium</b>
          </p>
          <img
            src={Kolkata}
            style={{ width: "250px", height:"280px" }}
            class="d-inline-block align-top"
            alt=""
          />
        </div>
      </div>
      <div class="card text-center m-3">
        <div class="card-body">
          <h5 class="card-title">INDORE</h5>
          <p>
            <b>Holkar Cricket Stadium</b>
          </p>
          <img
            src={Indore}
            style={{ width: "250px", height:"280px" }}
            class="d-inline-block align-top"
            alt=""
          />
        </div>
      </div>
      <div class="card text-center m-5">
        <div class="card-body">
          <h5 class="card-title">ASSAM</h5>
          <p>
            <b>Barsapara Cricket Stadium</b>
          </p>
          <img
            src={Assam}
            style={{ width: "250px", height:"280px" }}
            class="d-inline-block align-top"
            alt=""
          />
        </div>
      </div>
    </>
  );
};

export default Venues;
